import React from 'react'

const Backend = () => {
    return (
        <div className="skills_content">
            <h3 className="skills_title"><i class='bx bx-server'></i>Backend</h3>

            <div className="skills_list">
                <div className="skills_item"> C#</div>
                <div className="skills_item"> .NET</div>
                <div className="skills_item"> Node.js</div>
                <div className="skills_item"> REST APIs</div>
                <div className="skills_item"> SQL</div>
                <div className="skills_item"> xUnit</div>
            </div>
        </div>
    )
}

export default Backend